import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import { strip_get_params, teaser_attribute } from "../utils/_utils";
jQuery(function ($) {
  /**
   * Automatically select the chosen variation on the corresponding product teaser
   */
  jQuery(document).on('click', '.xts-product.product .xts-loop-swatch[data-attr="pa_' + teaser_attribute + '"]', function () {
    var variation_value = $(this).attr('data-value');
    var product_teaser = $(this).closest('.xts-product.product');
    var product_link = product_teaser.find('.xts-product-link');
    var product_title_link = product_teaser.find('.xts-entities-title a');
    var new_product_link = strip_get_params(product_link.attr('href')) + '?attribute_pa_' + teaser_attribute + '=' + variation_value;
    product_link.attr('href', new_product_link);
    product_title_link.attr('href', new_product_link);
  });
  jQuery(document).on('click', '.swatches-overlay', function () {
    var $container = $(this).closest('.xts-product-content');
    if ($container.hasClass('closed')) {
      $container.toggleClass('closed');
      $container.find('.all-colors').html('Weniger anzeigen...');
    } else {
      $container.toggleClass('closed');
      $container.find('.all-colors').html('Alle Farben');
    }
  });
});